import React from 'react';
import { Box, Card, CardHeader, CardContent, Stack, Typography, Checkbox } from '@mui/material';
import { useSelector } from 'react-redux';
import { ContactDataForm } from '../../ContactDataForm';
import { formatDate } from '../../../../../../services/functions';
import { SmallFormDateField } from '../../../../../../components/small-fields/SmallFormDateField';
import { SmallFormTextField } from '../../../../../../components/small-fields/SmallFormTextField';
import { getDiscountedGrossValuePerParticipantTitlesAction } from '../../../../../../services/request';
import { useQuery } from 'react-fetching-library';


const SettlementDataForm = ({ formik }) => {
  const { module, seasonYear } = useSelector(state => state.app);
  const [promoNameChoices, setPromoNameChoices] = React.useState([]);
  const optionsRequest = useQuery(getDiscountedGrossValuePerParticipantTitlesAction(null, 'OPTIONS'));

  console.log(formik.values.final_payment_date, formik.values.advance_payment_date);


  React.useEffect(() => {
    if (!optionsRequest.loading && !optionsRequest.error) {
      setPromoNameChoices(optionsRequest.payload.actions.GET.discounted_gross_value_per_participant_title.choices);
    }
  }, [optionsRequest.loading]);


  return (
    <Card sx={{ m: 2, mt: 0 }}>
      <CardHeader title="Dane zamawiającego" sx={{ mt: -1, mb: -2 }} />
      <CardContent>
        <form onSubmit={formik.handleSubmit} style={{ textAlign: 'center' }}>
          <ContactDataForm
            formik={formik}
            type="contractor"
            name="contractor_name"
            streetAddress="contractor_street_address"
            postalCode="contractor_postal_code"
            city="contractor_city"
            nipOrPesel="contractor_nip"
            phoneNumber="contractor_phone"
            email="contractor_correspondence_email"
            invoice="invoice"
          />
          <Box height={40}/>
          <Stack direction="row" justifyContent="start">
            <Stack direction="row" alignItems="center" justifyContent="center" spacing={1}>
              <Typography variant="subtitle2">termin wpłaty zaliczki</Typography>
              <SmallFormDateField
                standardTextField
                name="advance_payment_date"
                id="advance_payment_date"
                type="text"
                placeholder="termin wpłaty zaliczki"
                value={formik.values.advance_payment_date}
                onChange={val => formik.setFieldValue('advance_payment_date', formatDate(val))}
                error={Boolean(formik.errors.advance_payment_date)}
                helperText={formik.touched.advance_payment_date && formik.errors.advance_payment_date}
              />
            </Stack>
            <Box width={40}/>
            <Stack direction="row" alignItems="center" justifyContent="right" spacing={1}>
              <Typography variant="subtitle2">termin wpłaty końcowej</Typography>
              <SmallFormDateField
                standardTextField
                name="final_payment_date"
                id="final_payment_date"
                type="text"
                placeholder="termin wpłaty końcowej"
                value={formik.values.final_payment_date}
                onChange={val => formik.setFieldValue('final_payment_date', formatDate(val))}
                error={Boolean(formik.errors.final_payment_date)}
                helperText={formik.touched.final_payment_date && formik.errors.final_payment_date}
              />
            </Stack>
            {module == 'zielone_szkoly' ? <Stack direction="row" alignItems="center" justifyContent="right" spacing={1} ml={5}>
              <Typography variant="subtitle2">Ustaw terminy ręcznie</Typography>
              <Checkbox id="manual_payment_dates" name="manual_payment_dates" checked={formik.values.manual_payment_dates} onChange={formik.handleChange} />
            </Stack> : null}
          </Stack>
          <Box height={40}/>
          <Stack direction="row" justifyContent="start">
            <Stack direction="row" alignItems="center" justifyContent="right" spacing={1}>
              <Typography variant="subtitle2">Faktura wystawiona</Typography>
              <Checkbox id="is_invoice_issued" name="is_invoice_issued" checked={formik.values.is_invoice_issued} onChange={formik.handleChange} />
            </Stack>
            <Box width={40}/>
            <Stack direction="row" alignItems="center" justifyContent="right" spacing={1}>
              <Typography variant="subtitle2">Faktura zapłacona</Typography>
              <Checkbox id="is_invoice_paid" name="is_invoice_paid" checked={formik.values.is_invoice_paid} onChange={formik.handleChange} />
            </Stack>
            <Box width={40}/>
            <Stack direction="row" alignItems="center" justifyContent="right" spacing={1}>
              <Typography variant="subtitle2">Chcę fakturę</Typography>
              <Checkbox id="want_invoice" name="want_invoice" checked={formik.values.want_invoice} onChange={formik.handleChange} />
            </Stack>
            {module !== 'zielone_szkoly'
              ? null
              : <>
                <Stack direction="row" alignItems="center" justifyContent="right" spacing={1}>
                  <Typography variant="subtitle2">Wyliczaj na podstawie stałych wartości</Typography>
                  <Checkbox id="fixed_calculations_values" name="fixed_calculations_values" checked={formik.values.fixed_calculations_values} onChange={formik.handleChange} />
                </Stack>
                { formik.values.fixed_calculations_values
                  ? <Stack direction="column">
                    <Stack direction="row">
                      <Stack direction="row" alignItems="center" justifyContent="right" spacing={1} p={2}>
                        <Typography variant="subtitle2">Stała wartość brutto za każdego opiekuna</Typography>
                        <SmallFormTextField
                          error={formik.errors.fixed_gross_value_per_guardian && formik.touched.fixed_gross_value_per_guardian}
                          name="fixed_gross_value_per_guardian"
                          value={formik.values.fixed_gross_value_per_guardian}
                          onChange={formik.handleChange}
                          helperText={formik.errors.fixed_gross_value_per_guardian}
                        />
                      </Stack>
                      <Stack direction="row" alignItems="center" justifyContent="right" spacing={1} p={2}>
                        <Typography variant="subtitle2">Stała wartość brutto za każdego uczestnika</Typography>
                        <SmallFormTextField
                          error={formik.errors.fixed_gross_value_per_participant && formik.touched.fixed_gross_value_per_participant}
                          name="fixed_gross_value_per_participant"
                          value={formik.values.fixed_gross_value_per_participant}
                          onChange={formik.handleChange}
                          helperText={formik.errors.fixed_gross_value_per_participant}
                        />
                      </Stack>
                    </Stack>
                    <Stack direction="row">
                      {seasonYear < 2026 && <Stack direction="row" alignItems="center" justifyContent="right" mr={4} width="45%">
                        <Typography variant="subtitle2">Nazwa promocji dla zrabatowanej wartości brutto</Typography>
                        <SmallFormTextField
                          error={formik.errors.discounted_gross_value_per_participant_title && formik.touched.discounted_gross_value_per_participant_title}
                          sx={{ flex: '1 1 90%' }}
                          select
                          name="discounted_gross_value_per_participant_title"
                          options={promoNameChoices}
                          value={formik.values.discounted_gross_value_per_participant_title}
                          onChange={formik.handleChange}
                          helperText={formik.errors.discounted_gross_value_per_participant_title}
                        />
                      </Stack>}
                      {seasonYear < 2026 && <Stack direction="row" alignItems="center" justifyContent="right">
                        <Typography variant="subtitle2">Zrabatowana wartość brutto za każdego uczestnika</Typography>
                        <SmallFormTextField
                          error={formik.errors.discounted_gross_value_per_participant && formik.touched.discounted_gross_value_per_participant}
                          name="discounted_gross_value_per_participant"
                          value={formik.values.discounted_gross_value_per_participant}
                          onChange={formik.handleChange}
                          helperText={formik.errors.discounted_gross_value_per_participant}
                        />
                      </Stack>}
                    </Stack>
                  </Stack>
                  : null}
              </>
            }

          </Stack>
        </form>
      </CardContent>
    </Card>
  );
};


export default SettlementDataForm;
